<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData"   ref="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="orderId" label="订单ID">
             {{ formData.orderId ||'' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="deliveryId" label="提货单ID">
             {{ formData.deliveryId ||'' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="supplierName" label="供应商">
             {{ formData.supplierName ||'' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="purchaseType" label="付款类型">
             <span v-if="formData.purchaseType == '1'">保证金</span>
            <span v-if="formData.purchaseType == '2'">货款</span>
            <span v-if="formData.purchaseType == '3'">运费</span>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>

          <el-col :span="12">
            <el-form-item prop="purchaseDate" label="付款日期">
              {{ formData.purchaseDate||"" }}
            </el-form-item>

          </el-col>

          <el-col :span="12">
            <el-form-item prop="purchasePrice" label="付款金额">
              {{ formData.purchasePrice||"" }}
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="remark" label="备注说明">
             {{ formData.remark||"" }}
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList" disabled readonly></file-upload>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>

export default {
  name: 'supplierPaymentDetail',
  data () {
    return {
      specList: [],
      supplierArr: [],
      formData: {
        supplierId: '',
        purchaseType: '',
        purchasePrice: '',
        purchaseDate: '',
        remark: '',
        fileList: []
      },

      gysArr: [],
      typeArr: [
        {
          label: '保证金',
          value: '1'
        },
        {
          label: '货款',
          value: '2'
        },
        {
          label: '运费',
          value: '3'
        }

      ]

    }
  },
  created () {
    if (this.priceId) {
      this.loadData()
    }
  },
  computed: {
    priceId () {
      return this.$route.query.priceId
    }

  },
  methods: {

    loadData () {
      this.$axios.get(this.$apis.supplierPayment.selectYcSupplierPriceByPriceId, {
        params: { priceId: this.priceId }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []

        this.formData = res || {}
      })
    }

  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
